import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxx94z3b26: FaireProductEntity = {
  token: "p_mxx94z3b26",
  type: "product",
  name: "Minnesota Amber Honey 8 oz Bottle",
  brandName: "Bare Honey",
  imageUrl:
    "https://cdn.faire.com/fastly/62b751868428a5cddaf2a97093a00ba93b23de1b20755fe69671ec953f4c52ff.jpeg",
  priceDollars: 6.6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6e64a4f1c9a17690c28b6118791fd1b41125b3440f8fa44eaa8d77799ceaf7d7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
